export function evaluateChatHeight(element) {
    const chatContent = document.querySelector('.g-chatform-content');
    const chatForm = document.querySelector('.g-chatform');
    const HEIGHT_THRESHOLD = 100;
    const DISTANCE_BOTTOM_THRESHOLD = 20;
    const DISTANCE_UP_REMOVE_THRESHOLD = 100;
    const isEnabled = false;

    if (!isEnabled) {
        return;
    }

    if (
        !chatContent ||
        !chatForm ||
        !chatForm.classList.contains('has-compact-chat-content') ||
        chatContent.offsetHeight <= 200
    ) {
        return;
    }

    let lastScrollTop = 0;

    const handleScroll = () => {
        const scrollTop = chatContent.scrollTop;
        const scrollHeight = chatContent.scrollHeight;
        const clientHeight = chatContent.clientHeight;

        const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
        const scrollingDown = scrollTop > lastScrollTop;
        const scrollingUp = scrollTop < lastScrollTop;

        const isShort = scrollLength() < HEIGHT_THRESHOLD;

        if (isShort) {
            chatForm.classList.remove('chat-content-narrow');
        } else if (scrollingDown && distanceFromBottom <= DISTANCE_BOTTOM_THRESHOLD) {
            chatForm.classList.add('chat-content-narrow');
        } else if (scrollingUp && distanceFromBottom > DISTANCE_UP_REMOVE_THRESHOLD) {
            chatForm.classList.remove('chat-content-narrow');
        }

        lastScrollTop = Math.max(scrollTop, 0);
    };

    chatContent.addEventListener('scroll', handleScroll);

    // Ensure class is removed on load if too short
    if (scrollLength() < HEIGHT_THRESHOLD) {
        chatForm.classList.remove('chat-content-narrow');
    }

    function scrollLength() {
        return chatContent.scrollHeight - chatContent.clientHeight;
    }
}
